import type { RunStageDetail } from "../types.js";

const angles = { image: "画面与物件", voice: "人物口吻", tension: "悬念与反差", emotion: "情绪与关系", action: "具体行动" };

/** A reviewed title is not proof that the final manuscript transaction committed. */
export function ChapterTitleReceipt({ detail }: { detail: RunStageDetail }) {
  const review = detail.chapterTitleReview;
  const proposal = detail.chapterTitleProposal;
  if (!review && !proposal) return null;
  const candidates = review?.candidates ?? proposal?.candidates ?? [];
  const historical = Boolean(review && detail.convergence && detail.convergence.passedHash !== review.manuscriptHash);
  return <section className="stage-detail-sections" aria-label="章名创作与审定">
    <header><h3>章名创作与审定</h3><span>{historical ? "历史章名审定，不能用于当前稿" : review ? "终审已审定，发布以章节提交为准" : "文学编辑候选，尚未定名"}</span></header>
    {review && <details open>
      <summary><span><strong>{review.workingTitle} → {review.selected.title}</strong><small>工作名与正式候选分离，不改正文与账本事实</small></span></summary>
      <p>{review.selected.reason}</p>
      <p>剧透核对：{review.selected.spoilerReason}</p>
      <blockquote>{review.selected.evidence}</blockquote>
      {review.warnings.map((warning, index) => <p key={index}>{warning}</p>)}
    </details>}
    <details open={!review}>
      <summary><span><strong>{candidates.length ? `${candidates.length} 个候选章名` : "本次由终审直接审定"}</strong><small>不同角度比较，不用模型自评分排名</small></span></summary>
      {candidates.map((candidate, index) => <div key={`${index}-${candidate.title}`}>
        <h4>{candidate.title}{candidate.title === review?.selected.title ? historical ? " · 历史选用" : " · 终审选用" : ""}</h4>
        <p>{angles[candidate.angle]} · {candidate.reason}</p><blockquote>{candidate.evidence}</blockquote>
      </div>)}
    </details>
    <p>对应正文版本：{(review?.manuscriptHash ?? proposal?.manuscriptHash ?? "").slice(0, 12)}。这是该次审稿记录，后续正文修改不会自动沿用旧章名审定。</p>
  </section>;
}
